import api from "@/api";

const namespaced = true

const state = {
  fuelSupplies: [],
  fuelSuppliesFiles: {}
}

const getters = {
  fuelSupplies: state => state.fuelSupplies,
  fuelSuppliesFiles: state => state.fuelSuppliesFiles
}

const mutations = {
  SET_FUEL_SUPPLIES: (state, payload) => {
    state.fuelSupplies = payload
  },
  SET_FUEL_SUPPLIES_FILES: (state, payload) => {
    state.fuelSuppliesFiles = payload
  }
}

const actions = {
  async fetchFuelSupplyReports({ commit, rootGetters }, payload) {
    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const filterConfig = rootGetters['Table/defaultConfig']
      const filter = {
        search: filterConfig.search,
        page: filterConfig.currentPage,
        limit: filterConfig.pageSize,
        timezone,
        ...payload
      }

      const { data } = await api.getFuelSupplyReports(filter)

      if (data.error) {
        commit('SET_FUEL_SUPPLIES', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_FUEL_SUPPLIES', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
    } catch (err) {
      throw err
    }
  },
  async putFuelSupplyReport(_, payload) {
    try {
      await api.putFuelSupplyReport(payload.id, payload.form)
    } catch ({ data }) {
      throw data
    }
  },
  async downloadFuelSupplyReport({ commit, rootGetters }, payload) {
    try {
      let reportType
      if (payload?.type) {
        reportType = payload.type
        delete payload.type
      }

      const filterConfig = rootGetters['Table/defaultConfig']
      const filter = {
        search: filterConfig.search,
        ...payload
      }

      const response = reportType === 'bunker_report'
        ? await api.getDailyBunkerReportExcelDownload(filter)
        : await api.getFuelSupplyReportExcelDownload(filter)

      if (response) {
        commit('SET_FUEL_SUPPLIES_FILES', response)
      }
    } catch (err) {
      throw err
    }
  },
  resetFuelSuppliesFiles({ commit }) {
    commit('SET_FUEL_SUPPLIES_FILES', {})
  }
}

export default { namespaced, state, getters, mutations, actions }